import './style.css'

const urlInput = document.getElementById('url-input')
const loadBtn = document.getElementById('load-btn')
const iframeContainer = document.getElementById('iframe-container')
const iframe = document.getElementById('estimator-iframe')

function isValidUrl(url) {
    try {
        const urlObj = new URL(url)
        return urlObj.protocol === 'https:' && urlObj.hostname.includes('valeur.io')
    } catch {
        return false
    }
}

function showError(message) {
    const existingError = document.getElementById('error-message')
    if (existingError) {
        existingError.remove()
    }

    const errorDiv = document.createElement('div')
    errorDiv.id = 'error-message'
    errorDiv.className = 'error-message'
    errorDiv.textContent = message
    iframeContainer.insertAdjacentElement('beforebegin', errorDiv)
}

function clearError() {
    const existingError = document.getElementById('error-message')
    if (existingError) {
        existingError.remove()
    }
}

urlInput.addEventListener('input', function() {
    loadBtn.disabled = !isValidUrl(this.value)
    clearError()
})

function loadIframe() {
    const url = urlInput.value
    if (isValidUrl(url)) {
        clearError()
        iframe.src = url
        iframeContainer.style.display = 'block'

        // Add error event listener to iframe
        iframe.onerror = () => {
            showError('Failed to load the Estimator. This might be due to CORS restrictions. Please ensure the server allows iframe embedding from this domain.')
        }

        // Add load event listener to check if iframe loaded successfully
        iframe.onload = () => {
            // Iframe loaded successfully - no need to check contentWindow access
            // The iframe content is visible, which means it loaded properly
            console.log('Iframe loaded successfully')
        }
    }
}

loadBtn.addEventListener('click', loadIframe)

// Support Enter key
urlInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter' && !loadBtn.disabled) {
        loadIframe()
    }
}) 